/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProtectedTaxRegimeSelectorRouteImport } from './routes/_protected.tax-regime-selector'
import { Route as ProtectedRewardsRouteImport } from './routes/_protected.rewards'
import { Route as ProtectedReferralsRouteImport } from './routes/_protected.referrals'
import { Route as ProtectedQuestionnaireRouteImport } from './routes/_protected.questionnaire'
import { Route as ProtectedProfileRouteImport } from './routes/_protected.profile'
import { Route as ProtectedItActRouteImport } from './routes/_protected.it-act'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected.dashboard'
import { Route as ProtectedChannelPartnerIndexRouteImport } from './routes/_protected.channel-partner.index'
import { Route as ProtectedServiceRequestIdRouteImport } from './routes/_protected.service-request.$id'
import { Route as ProtectedChannelPartnerHubRouteImport } from './routes/_protected.channel-partner.hub'
import { Route as ProtectedChannelPartnerApplyRouteImport } from './routes/_protected.channel-partner.apply'
import { Route as ProtectedChannelPartnerHubIndexRouteImport } from './routes/_protected.channel-partner.hub.index'
import { Route as ProtectedServiceRequestNewServiceTypeRouteImport } from './routes/_protected.service-request.new.$serviceType'
import { Route as ProtectedChannelPartnerHubServicesRouteImport } from './routes/_protected.channel-partner.hub.services'
import { Route as ProtectedChannelPartnerHubProfileRouteImport } from './routes/_protected.channel-partner.hub.profile'
import { Route as ProtectedChannelPartnerHubCustomersRouteImport } from './routes/_protected.channel-partner.hub.customers'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedTaxRegimeSelectorRoute =
  ProtectedTaxRegimeSelectorRouteImport.update({
    id: '/tax-regime-selector',
    path: '/tax-regime-selector',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedRewardsRoute = ProtectedRewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedReferralsRoute = ProtectedReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedQuestionnaireRoute = ProtectedQuestionnaireRouteImport.update({
  id: '/questionnaire',
  path: '/questionnaire',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedProfileRoute = ProtectedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedItActRoute = ProtectedItActRouteImport.update({
  id: '/it-act',
  path: '/it-act',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedChannelPartnerIndexRoute =
  ProtectedChannelPartnerIndexRouteImport.update({
    id: '/channel-partner/',
    path: '/channel-partner/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedServiceRequestIdRoute =
  ProtectedServiceRequestIdRouteImport.update({
    id: '/service-request/$id',
    path: '/service-request/$id',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedChannelPartnerHubRoute =
  ProtectedChannelPartnerHubRouteImport.update({
    id: '/channel-partner/hub',
    path: '/channel-partner/hub',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedChannelPartnerApplyRoute =
  ProtectedChannelPartnerApplyRouteImport.update({
    id: '/channel-partner/apply',
    path: '/channel-partner/apply',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedChannelPartnerHubIndexRoute =
  ProtectedChannelPartnerHubIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedChannelPartnerHubRoute,
  } as any)
const ProtectedServiceRequestNewServiceTypeRoute =
  ProtectedServiceRequestNewServiceTypeRouteImport.update({
    id: '/service-request/new/$serviceType',
    path: '/service-request/new/$serviceType',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedChannelPartnerHubServicesRoute =
  ProtectedChannelPartnerHubServicesRouteImport.update({
    id: '/services',
    path: '/services',
    getParentRoute: () => ProtectedChannelPartnerHubRoute,
  } as any)
const ProtectedChannelPartnerHubProfileRoute =
  ProtectedChannelPartnerHubProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => ProtectedChannelPartnerHubRoute,
  } as any)
const ProtectedChannelPartnerHubCustomersRoute =
  ProtectedChannelPartnerHubCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => ProtectedChannelPartnerHubRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/it-act': typeof ProtectedItActRoute
  '/profile': typeof ProtectedProfileRoute
  '/questionnaire': typeof ProtectedQuestionnaireRoute
  '/referrals': typeof ProtectedReferralsRoute
  '/rewards': typeof ProtectedRewardsRoute
  '/tax-regime-selector': typeof ProtectedTaxRegimeSelectorRoute
  '/channel-partner/apply': typeof ProtectedChannelPartnerApplyRoute
  '/channel-partner/hub': typeof ProtectedChannelPartnerHubRouteWithChildren
  '/service-request/$id': typeof ProtectedServiceRequestIdRoute
  '/channel-partner/': typeof ProtectedChannelPartnerIndexRoute
  '/channel-partner/hub/customers': typeof ProtectedChannelPartnerHubCustomersRoute
  '/channel-partner/hub/profile': typeof ProtectedChannelPartnerHubProfileRoute
  '/channel-partner/hub/services': typeof ProtectedChannelPartnerHubServicesRoute
  '/service-request/new/$serviceType': typeof ProtectedServiceRequestNewServiceTypeRoute
  '/channel-partner/hub/': typeof ProtectedChannelPartnerHubIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/it-act': typeof ProtectedItActRoute
  '/profile': typeof ProtectedProfileRoute
  '/questionnaire': typeof ProtectedQuestionnaireRoute
  '/referrals': typeof ProtectedReferralsRoute
  '/rewards': typeof ProtectedRewardsRoute
  '/tax-regime-selector': typeof ProtectedTaxRegimeSelectorRoute
  '/channel-partner/apply': typeof ProtectedChannelPartnerApplyRoute
  '/service-request/$id': typeof ProtectedServiceRequestIdRoute
  '/channel-partner': typeof ProtectedChannelPartnerIndexRoute
  '/channel-partner/hub/customers': typeof ProtectedChannelPartnerHubCustomersRoute
  '/channel-partner/hub/profile': typeof ProtectedChannelPartnerHubProfileRoute
  '/channel-partner/hub/services': typeof ProtectedChannelPartnerHubServicesRoute
  '/service-request/new/$serviceType': typeof ProtectedServiceRequestNewServiceTypeRoute
  '/channel-partner/hub': typeof ProtectedChannelPartnerHubIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_protected/dashboard': typeof ProtectedDashboardRoute
  '/_protected/it-act': typeof ProtectedItActRoute
  '/_protected/profile': typeof ProtectedProfileRoute
  '/_protected/questionnaire': typeof ProtectedQuestionnaireRoute
  '/_protected/referrals': typeof ProtectedReferralsRoute
  '/_protected/rewards': typeof ProtectedRewardsRoute
  '/_protected/tax-regime-selector': typeof ProtectedTaxRegimeSelectorRoute
  '/_protected/channel-partner/apply': typeof ProtectedChannelPartnerApplyRoute
  '/_protected/channel-partner/hub': typeof ProtectedChannelPartnerHubRouteWithChildren
  '/_protected/service-request/$id': typeof ProtectedServiceRequestIdRoute
  '/_protected/channel-partner/': typeof ProtectedChannelPartnerIndexRoute
  '/_protected/channel-partner/hub/customers': typeof ProtectedChannelPartnerHubCustomersRoute
  '/_protected/channel-partner/hub/profile': typeof ProtectedChannelPartnerHubProfileRoute
  '/_protected/channel-partner/hub/services': typeof ProtectedChannelPartnerHubServicesRoute
  '/_protected/service-request/new/$serviceType': typeof ProtectedServiceRequestNewServiceTypeRoute
  '/_protected/channel-partner/hub/': typeof ProtectedChannelPartnerHubIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/dashboard'
    | '/it-act'
    | '/profile'
    | '/questionnaire'
    | '/referrals'
    | '/rewards'
    | '/tax-regime-selector'
    | '/channel-partner/apply'
    | '/channel-partner/hub'
    | '/service-request/$id'
    | '/channel-partner/'
    | '/channel-partner/hub/customers'
    | '/channel-partner/hub/profile'
    | '/channel-partner/hub/services'
    | '/service-request/new/$serviceType'
    | '/channel-partner/hub/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/signup'
    | '/dashboard'
    | '/it-act'
    | '/profile'
    | '/questionnaire'
    | '/referrals'
    | '/rewards'
    | '/tax-regime-selector'
    | '/channel-partner/apply'
    | '/service-request/$id'
    | '/channel-partner'
    | '/channel-partner/hub/customers'
    | '/channel-partner/hub/profile'
    | '/channel-partner/hub/services'
    | '/service-request/new/$serviceType'
    | '/channel-partner/hub'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/login'
    | '/signup'
    | '/_protected/dashboard'
    | '/_protected/it-act'
    | '/_protected/profile'
    | '/_protected/questionnaire'
    | '/_protected/referrals'
    | '/_protected/rewards'
    | '/_protected/tax-regime-selector'
    | '/_protected/channel-partner/apply'
    | '/_protected/channel-partner/hub'
    | '/_protected/service-request/$id'
    | '/_protected/channel-partner/'
    | '/_protected/channel-partner/hub/customers'
    | '/_protected/channel-partner/hub/profile'
    | '/_protected/channel-partner/hub/services'
    | '/_protected/service-request/new/$serviceType'
    | '/_protected/channel-partner/hub/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/tax-regime-selector': {
      id: '/_protected/tax-regime-selector'
      path: '/tax-regime-selector'
      fullPath: '/tax-regime-selector'
      preLoaderRoute: typeof ProtectedTaxRegimeSelectorRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/rewards': {
      id: '/_protected/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof ProtectedRewardsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/referrals': {
      id: '/_protected/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof ProtectedReferralsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/questionnaire': {
      id: '/_protected/questionnaire'
      path: '/questionnaire'
      fullPath: '/questionnaire'
      preLoaderRoute: typeof ProtectedQuestionnaireRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/profile': {
      id: '/_protected/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProtectedProfileRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/it-act': {
      id: '/_protected/it-act'
      path: '/it-act'
      fullPath: '/it-act'
      preLoaderRoute: typeof ProtectedItActRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/channel-partner/': {
      id: '/_protected/channel-partner/'
      path: '/channel-partner'
      fullPath: '/channel-partner/'
      preLoaderRoute: typeof ProtectedChannelPartnerIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/service-request/$id': {
      id: '/_protected/service-request/$id'
      path: '/service-request/$id'
      fullPath: '/service-request/$id'
      preLoaderRoute: typeof ProtectedServiceRequestIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/channel-partner/hub': {
      id: '/_protected/channel-partner/hub'
      path: '/channel-partner/hub'
      fullPath: '/channel-partner/hub'
      preLoaderRoute: typeof ProtectedChannelPartnerHubRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/channel-partner/apply': {
      id: '/_protected/channel-partner/apply'
      path: '/channel-partner/apply'
      fullPath: '/channel-partner/apply'
      preLoaderRoute: typeof ProtectedChannelPartnerApplyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/channel-partner/hub/': {
      id: '/_protected/channel-partner/hub/'
      path: '/'
      fullPath: '/channel-partner/hub/'
      preLoaderRoute: typeof ProtectedChannelPartnerHubIndexRouteImport
      parentRoute: typeof ProtectedChannelPartnerHubRoute
    }
    '/_protected/service-request/new/$serviceType': {
      id: '/_protected/service-request/new/$serviceType'
      path: '/service-request/new/$serviceType'
      fullPath: '/service-request/new/$serviceType'
      preLoaderRoute: typeof ProtectedServiceRequestNewServiceTypeRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/channel-partner/hub/services': {
      id: '/_protected/channel-partner/hub/services'
      path: '/services'
      fullPath: '/channel-partner/hub/services'
      preLoaderRoute: typeof ProtectedChannelPartnerHubServicesRouteImport
      parentRoute: typeof ProtectedChannelPartnerHubRoute
    }
    '/_protected/channel-partner/hub/profile': {
      id: '/_protected/channel-partner/hub/profile'
      path: '/profile'
      fullPath: '/channel-partner/hub/profile'
      preLoaderRoute: typeof ProtectedChannelPartnerHubProfileRouteImport
      parentRoute: typeof ProtectedChannelPartnerHubRoute
    }
    '/_protected/channel-partner/hub/customers': {
      id: '/_protected/channel-partner/hub/customers'
      path: '/customers'
      fullPath: '/channel-partner/hub/customers'
      preLoaderRoute: typeof ProtectedChannelPartnerHubCustomersRouteImport
      parentRoute: typeof ProtectedChannelPartnerHubRoute
    }
  }
}

interface ProtectedChannelPartnerHubRouteChildren {
  ProtectedChannelPartnerHubCustomersRoute: typeof ProtectedChannelPartnerHubCustomersRoute
  ProtectedChannelPartnerHubProfileRoute: typeof ProtectedChannelPartnerHubProfileRoute
  ProtectedChannelPartnerHubServicesRoute: typeof ProtectedChannelPartnerHubServicesRoute
  ProtectedChannelPartnerHubIndexRoute: typeof ProtectedChannelPartnerHubIndexRoute
}

const ProtectedChannelPartnerHubRouteChildren: ProtectedChannelPartnerHubRouteChildren =
  {
    ProtectedChannelPartnerHubCustomersRoute:
      ProtectedChannelPartnerHubCustomersRoute,
    ProtectedChannelPartnerHubProfileRoute:
      ProtectedChannelPartnerHubProfileRoute,
    ProtectedChannelPartnerHubServicesRoute:
      ProtectedChannelPartnerHubServicesRoute,
    ProtectedChannelPartnerHubIndexRoute: ProtectedChannelPartnerHubIndexRoute,
  }

const ProtectedChannelPartnerHubRouteWithChildren =
  ProtectedChannelPartnerHubRoute._addFileChildren(
    ProtectedChannelPartnerHubRouteChildren,
  )

interface ProtectedRouteChildren {
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
  ProtectedItActRoute: typeof ProtectedItActRoute
  ProtectedProfileRoute: typeof ProtectedProfileRoute
  ProtectedQuestionnaireRoute: typeof ProtectedQuestionnaireRoute
  ProtectedReferralsRoute: typeof ProtectedReferralsRoute
  ProtectedRewardsRoute: typeof ProtectedRewardsRoute
  ProtectedTaxRegimeSelectorRoute: typeof ProtectedTaxRegimeSelectorRoute
  ProtectedChannelPartnerApplyRoute: typeof ProtectedChannelPartnerApplyRoute
  ProtectedChannelPartnerHubRoute: typeof ProtectedChannelPartnerHubRouteWithChildren
  ProtectedServiceRequestIdRoute: typeof ProtectedServiceRequestIdRoute
  ProtectedChannelPartnerIndexRoute: typeof ProtectedChannelPartnerIndexRoute
  ProtectedServiceRequestNewServiceTypeRoute: typeof ProtectedServiceRequestNewServiceTypeRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedDashboardRoute: ProtectedDashboardRoute,
  ProtectedItActRoute: ProtectedItActRoute,
  ProtectedProfileRoute: ProtectedProfileRoute,
  ProtectedQuestionnaireRoute: ProtectedQuestionnaireRoute,
  ProtectedReferralsRoute: ProtectedReferralsRoute,
  ProtectedRewardsRoute: ProtectedRewardsRoute,
  ProtectedTaxRegimeSelectorRoute: ProtectedTaxRegimeSelectorRoute,
  ProtectedChannelPartnerApplyRoute: ProtectedChannelPartnerApplyRoute,
  ProtectedChannelPartnerHubRoute: ProtectedChannelPartnerHubRouteWithChildren,
  ProtectedServiceRequestIdRoute: ProtectedServiceRequestIdRoute,
  ProtectedChannelPartnerIndexRoute: ProtectedChannelPartnerIndexRoute,
  ProtectedServiceRequestNewServiceTypeRoute:
    ProtectedServiceRequestNewServiceTypeRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
